import {useInfiniteQuery} from 'react-query';
import {getMyChats} from '.';

const useGetMyChats = () => {
  const {data, isLoading, hasNextPage, fetchNextPage} = useInfiniteQuery(
    ['my-chats'],
    ({pageParam = 1}) => getMyChats(pageParam),
    {
      getNextPageParam: (_, allPages) => {
        return allPages[allPages.length - 1]?.next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    },
  );

  return {data, isLoading, hasNextPage, fetchNextPage};
};

export default useGetMyChats;
